import { TDeconstructTenantIdResult } from "../types/common.types";

export function getPathParts(pathName: string): Array<string> {
  return pathName.split("/");
}

export function getAppNameByPathName(pathName: string): string {
  return getPathParts(pathName)[1];
}

export function humanize(label: string): string {
  let result = "";
  let shouldCapitalize = false;

  const capitalizeLetter = (letter: string): string => letter.toUpperCase();

  Array.from(label).forEach((character, index) => {
    if (index === 0 || shouldCapitalize) {
      result += capitalizeLetter(character);
    } else if (capitalizeLetter(character) === character) {
      shouldCapitalize = true;
      result += ` ${capitalizeLetter(character)}`;
    } else {
      result += character;
    }

    shouldCapitalize = false;
  });

  return result;
}

function deconstructTenantId(tenantId: string): TDeconstructTenantIdResult {
  // ea8d19f6-a77b-4e85-9573-bc097c0eecea|null|965690b7-7907-4559-b00a-24484fea2662|5|a7d87790-1f5f-4cd8-87bd-dce85829869a
  const [
    managementCompanyGuid,
    hoaGuid,
    assetOwnGuid,
    residentalUnitId,
    tenantOwnGuid,
  ] = tenantId.split("|");

  return {
    management_company_guid: managementCompanyGuid,
    hoa_guid: hoaGuid,
    asset_own_guid: assetOwnGuid,
    residental_unit_id: residentalUnitId,
    tenant_own_guid: tenantOwnGuid,
  };
}

export function extractAssetIdByTenantId(tenantId: string) {
  const { management_company_guid, hoa_guid, asset_own_guid } =
    deconstructTenantId(tenantId);

  return `${management_company_guid}|${hoa_guid}|${asset_own_guid}`;
}

export function groupBy<T, K extends keyof any>(
  array: T[],
  key: keyof T | ((item: T) => K),
): Record<K, T[]> {
  return array.reduce(
    (acc: Record<K, T[]>, item: T) => {
      const groupKey = typeof key === "function" ? key(item) : (item[key] as K);

      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }

      acc[groupKey].push(item);
      return acc;
    },
    {} as Record<K, T[]>,
  );
}
